/** The only values Organization.schedule_day_statuses may contain. Mirrors
 * ALLOWED_SCHEDULE_DAY_STATUSES in backend scheduling/schedule_statuses.py, which
 * rejects anything else on write. Keep the two lists in step. */
export const SCHEDULE_DAY_STATUS_KEYS = [
  'in_office',
  'remote',
  'present_uni',
  'holiday',
  'sick',
  'study',
] as const

export interface Employee {
  id: string
  first_name: string
  last_name: string
  work_email: string
  office_phone_number?: string
  phone_number?: string
  profile_picture?: string
}

export interface Address {
  address1: string
  address2: string
  country: string
  city: string
  zipCode: string
}

export interface Organization {
  id: string
  logo: string | null
  legal_name: string
  display_name: string
  url: string
  email: string
  phone_number: string
  email_domain?: string
  pilot_start: string | null
  license_start: string | null
  postal_address: Address
  visiting_address: Address
  vat_number: string
  invoice_address: Address
  primary_contact: Employee | null
  secondary_contact: Employee | null
  tertiary_contact: Employee | null
  invoice_contact: Employee | null
  invite_token?: string
  created_at?: string
  updated_at?: string
  used_input_tokens?: number
  used_output_tokens?: number
  mfa_required?: boolean
  show_pending_requests_on_calendar?: boolean
  enable_office_arrival_reminders?: boolean
  enable_weekend_status?: boolean
  /** Statuses the weekly schedule picker offers; empty = the office/remote default.
   * Always a list of SCHEDULE_DAY_STATUS_KEYS — mapApiOrganizationToOrganization
   * normalizes the raw JSONField, which can hold any JSON at all. */
  schedule_day_statuses: string[]
  /** Read-only — only ever set by the admin-consent callback, never client-editable. */
  entra_tenant_id?: string
  entra_anchor_upn?: string
  entra_consent_granted_at?: string | null
}

export interface UpdateOrganizationPayload {
  logo?: File | string | null
  legal_name?: string
  display_name?: string
  url?: string
  email?: string
  phone_number?: string
  email_domain?: string
  pilot_start?: string | null
  license_start?: string | null
  postal_address?: Address
  visiting_address?: Address
  vat_number?: string
  invoice_address?: Address
  primary_contact?: string | null
  secondary_contact?: string | null
  tertiary_contact?: string | null
  invoice_contact?: string | null
  show_pending_requests_on_calendar?: boolean
  enable_office_arrival_reminders?: boolean
  enable_weekend_status?: boolean
  /** Statuses the weekly schedule picker offers; empty = office/remote/university. */
  schedule_day_statuses?: string[]
  entra_anchor_upn?: string
}
